import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Typography,
} from "@mui/material";
import { formatter } from "../../../util/formatter";
import { FunctionComponent } from "react";

type PropsType = {
  subtotal?: number;
  shipping: number;
  total: number;
  totalTax: number;
  fees?: number;
  discount?: number;
  orderWeight?: number;
};

const AmountTable: FunctionComponent<PropsType> = ({
  subtotal,
  shipping,
  total,
  totalTax,
  fees,
  discount,
  orderWeight,
}) => {
  return (
    <Table sx={{ border: "1 0 0 0" }} size="small">
      <TableHead>
        <TableRow sx={{ background: "var(--header)" }}>
          <TableCell colSpan={12} sx={{ color: "var(--white)" }}>
            <span>Total Price</span>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {subtotal !== undefined && (
          <TableRow>
            <TableCell>Product</TableCell>
            <TableCell align="right">{formatter.format(subtotal)}</TableCell>
          </TableRow>
        )}
        {fees !== undefined && fees > 0 && (
          <TableRow>
            <TableCell>Total Fees</TableCell>
            <TableCell align="right">{formatter.format(fees)}</TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell>Shipping</TableCell>
          <TableCell align="right">{formatter.format(shipping)}</TableCell>
        </TableRow>
        {orderWeight !== undefined && (
          <TableRow>
            <TableCell>Weight</TableCell>
            <TableCell align="right">{orderWeight.toFixed(1)}kg</TableCell>
          </TableRow>
        )}
        {discount !== undefined && (
          <TableRow>
            <TableCell>Discount</TableCell>
            <TableCell align="right">{formatter.format(discount)}</TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell>Total price excl. VAT</TableCell>
          <TableCell align="right">{formatter.format(total)}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>VAT (25%)</TableCell>
          <TableCell align="right">{formatter.format(totalTax ?? 0)}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Typography fontWeight={"bold"}>Total price incl. VAT</Typography>
          </TableCell>
          <TableCell align="right" sx={{ fontWeight: "bold" }}>
            {formatter.format(total + totalTax)}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default AmountTable;
